import React, { Component } from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../modules/SimpleInput";
import FlexView from "react-flexview";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { INITIAL_FILTER_VALUE } from "../config";
import moment from "moment";

class MasterHargaJasaFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: INITIAL_FILTER_VALUE,
    };
  }

  componentDidMount() {
    this.setState({
      filter: this.props.submitedFilter,
    });
  }

  handleValueChange = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      filter: {
        ...prev.filter,
        [name]: value,
      },
    }));
  };

  handleClear = () => {
    this.setState({
      filter: {
        ...INITIAL_FILTER_VALUE,
        startTanggalBerlaku: null,
        endTanggalBerlaku: null,
      },
    });
  };

  handleSubmitFilter = () => {
    this.props.handleSubmitFilter(this.state.filter);
    this.props.onClickClose();
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { filter } = this.state;
    return (
      <SimpleModal
        title="Filter"
        visible={visible}
        onClickClose={() => onClickClose()}
        content={
          <ModalContainer>
            <FlexView column style={{ gap: "10px" }}>
              <SimpleInput
                id="input_kode_dokumen"
                name="kodeDokumen"
                label="Kode Dokumen"
                containerclassname="width width-full"
                value={filter.kodeDokumen}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <FlexView vAlignContent="center" column style={{ gap: "10px" }}>
                <p className="margin margin-bottom-15px">Tanggal Berlaku</p>
                <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                  <div className="width width-full">
                    <SimpleDate
                      id="data_picker_start_date"
                      name="startTanggalBerlaku"
                      nextdate
                      date={filter?.startTanggalBerlaku}
                      onChange={(value) =>
                        this.handleValueChange(
                          "startTanggalBerlaku",
                          moment(value).format("DD-MM-YYYY")
                        )
                      }
                    />
                  </div>
                  <p className="margin margin-bottom-15px">s/d</p>
                  <div className="width width-full">
                    <SimpleDate
                      id="data_picker_end_date"
                      name="endTanggalBerlaku"
                      backdate
                      date={filter?.endTanggalBerlaku}
                      minDate={filter?.startTanggalBerlaku}
                      onChange={(value) =>
                        this.handleValueChange(
                          "endTanggalBerlaku",
                          moment(value).format("DD-MM-YYYY")
                        )
                      }
                    />
                  </div>
                </FlexView>
              </FlexView>
              <SimpleInput
                id="input_main_dealer"
                name="mainDealer"
                label="Main Dealer"
                containerclassname="width width-full"
                value={filter?.mainDealer}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_cabang_berlaku"
                name="cabangBerlaku"
                label="Cabang Berlaku"
                containerclassname="width width-full"
                value={filter?.cabangBerlaku}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_kode_jasa_job"
                name="kodeJasa"
                label="Kode Jasa/Job"
                containerclassname="width width-full"
                value={filter?.kodeJasa}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_nama_jasa_job"
                name="namaJasa"
                label="Nama Jasa/Job"
                containerclassname="width width-full"
                value={filter?.namaJasa}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_kode_varian"
                name="kodeVarian"
                label="Kode Varian"
                containerclassname="width width-full"
                value={filter?.kodeVarian}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
              <SimpleInput
                id="input_nama_varian"
                name="namaVarian"
                label="Nama Varian"
                containerclassname="width width-full"
                value={filter?.namaVarian}
                onChange={({ target }) =>
                  this.handleValueChange(target.name, target.value)
                }
              />
            </FlexView>
            <FlexView style={{ justifyContent: "flex-end" }}>
              <SimpleButton
                text="HAPUS"
                id="btn-delete"
                onClick={this.handleClear}
              />
              <SimpleButton
                text="TERAPKAN"
                id="btn-submit"
                onClick={this.handleSubmitFilter}
              />
            </FlexView>
          </ModalContainer>
        }
      />
    );
  }
}

export default MasterHargaJasaFilter;
